import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/internal/Observable';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

const TOKEN_HEADER_KEY = 'Authorization';


@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    const httpOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': this.authenticationService.getToken()
    });
    let authReq = req;
    const token = this.authenticationService.getToken();

    if (token != null) {
      authReq = req.clone({ headers: httpOptions });
    }
    return next.handle(authReq);
    // return from(this.authenticationService.getToken())
    //   .pipe(
    //     switchMap(token => {
    //       console.log("in side switch map")
    //       console.log(token)
    //       if (token != null) {
    //         req = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + token) });
    //       }

    //       if (!req.headers.has('Content-Type')) {
    //         req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    //       }
    //       return next.handle(req);
    //     })
    //   );

  }






  //   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //     return from(this.storage.get(TOKEN_KEY))
  //         .pipe(
  //             switchMap(token => {
  //                 if (token) {
  //                     request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
  //                 }

  //                 if (!request.headers.has('Content-Type')) {
  //                     request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
  //                 }
  //                 return next.handle(request);
  //             })
  //         );
  // }
}
